import { FC } from 'react';
import { ListGroupItem } from 'reactstrap';
import { EntEventsLogType } from 'src/Types';

interface INotificationItemProps {
	notification: EntEventsLogType;
	onClick: () => void;
	onDismiss: ( recid: string ) => void;
};

export const NotificationItem: FC<INotificationItemProps> = ( props ) => {
	
	const { notification, onClick, onDismiss } = props;

	const date = new Date(notification.reccreated);
	const offset = new Date(Date.now()).getTimezoneOffset();
	const correctedDate = date.setMinutes(-offset + date.getMinutes());

	const color = typeToColor( !!notification.eventType ? notification.eventType : 0 );

	return (
		<div className="animated fadeIn">
			<ListGroupItem
				color={color}
				className={`list-group-item-accent-${color} animated fadeIn rdev__notify__listitem`}
				style={{ background: color !== "danger" ? "#d4edda" : "#f8d7da" }}
			>
				
				<button type="button" className="close rdev__notify__listitem-close" aria-label="Close" onClick={() => onDismiss(notification.recid)}>
					<span aria-hidden="true">&times;</span>
				</button>
		
				<div onClick={onClick} className='rdev__notify__listitem-textblock'>
					<div className='rdev__notify__listitem-text' dangerouslySetInnerHTML={{ __html: notification.message }} />
					<small className="text-muted mr-3">
						<i className="icon-calendar"></i>
						&nbsp;
						{new Date(correctedDate).toLocaleString()}
					</small>
				</div>
		
			</ListGroupItem>
		</div>
	);
};

const typeToColor = ( eventType: number ) => {
	switch (eventType) {
		case 1:
		case 2:
		case 3:
			return "success";
		case 4:
			return "danger";
		default:
			return "info";
	}
};
